export const getErrorMessage = (error: unknown): string => {
    if (!error) return "An unknown error occurred";
    
    if (typeof error === 'object' && 'data' in error) {
      const data = (error as { data: unknown }).data;
      if (data && typeof data === 'object' && 'message' in data) {
        return String((data as { message: unknown }).message);
      }
    }
    
    if (typeof error === 'object' && 'message' in error && error.message) {
      return String(error.message);
    }
    
    if (typeof error === 'object' && 'error' in error && error.error) {
      return String(error.error);
    }
    
    return "An unknown error occurred";
  };